import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import Help from 'src/modules/UserSettings/Help/View/Help';
import HelpArticle from 'src/modules/UserSettings/Help/Article/HelpArticle';
import HelpArticleForm from 'src/modules/UserSettings/Help/Form/HelpArticleForm';
import HelpCategory from 'src/modules/UserSettings/Help/Category/HelpCategory';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.HELP],
    component: Help,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.HELP_ARTICLE],
    component: HelpArticle,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths: [routes.HELP_CATEGORY],
    component: HelpCategory,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN, UserTypes.LAWENFORCEMENTAGENT]
  },
  {
    paths:[routes.HELP_ARTICLE_FORM],
    component: HelpArticleForm,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  }
]);

export const helpModule = (): IRouteModule => ({
  name: RoutesModules.HELP,
  routes: moduleRoutes(),
  navbar: routes.HELP
});